import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Ação Tipo de Não Conformidade',
    path: '/nao-conformidade/ncoacaotipo',
    name: 'ncoacaotipo',
    goesToMenu: true,
    component: () => import('@/views/nao-conformidade/nco-acao-tipo/components/GridIndex.vue'),
    meta: {
      permissions: [EPermissoes.NaoConformidade_Configuracao],
      escopoObra: 'global'
    }
  },
  {
    description: 'Cadastro de Ação Tipo de Não Conformidade',
    path: '/nao-conformidade/nco-acao-tipo/cadastro',
    parent: 'ncoacaotipo',
    name: 'ncoacaotipo-insert',
    component: () => import('@/views/nao-conformidade/nco-acao-tipo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ncoacaotipo',
      permissions: [EPermissoes.NaoConformidade_Configuracao]
    }
  },
  {
    description: 'Edição de Ação Tipo de Não Conformidade',
    path: '/nao-conformidade/nco-acao-tipo/cadastro/:id',
    parent: 'ncoacaotipo',
    name: 'ncoacaotipo-update',
    component: () => import('@/views/nao-conformidade/nco-acao-tipo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'ncoacaotipo',
      permissions: [EPermissoes.NaoConformidade_Configuracao]
    }
  }
];
